@layer components {
  .option {
    composes: field from '../styles/field.module.css';
    padding: var(--space-small);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    /* Lista ma overflow, więc obrys rysujemy do środka. */
    &:focus-visible {
      outline-offset: -2px;
    }

    &:last-child {
      border-bottom-left-radius: var(--radius);
      border-bottom-right-radius: var(--radius);
    }
  }
}
